import * as React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
const faqs = [{
  question: "What certifications are required to rent machinery?",
  answer: "Most mid-size equipment requires a valid operator's certificate or proof of competency. Our team will verify credentials during the rental agreement process to ensure worksite safety and compliance with local regulations."
}, {
  question: "Do you offer job site delivery and pickup?",
  answer: "Yes, we provide professional hauling services directly to your construction site. Delivery fees are calculated based on the distance from our nearest fleet hub and the size of the equipment being transported."
}, {
  question: "What happens if a machine breaks down on site?",
  answer: "Our equipment is rigorously maintained. In the rare event of a mechanical failure, our mobile service technicians are dispatched immediately to minimize your downtime or provide a replacement unit if necessary."
}, {
  question: "Are attachments like augers or trenchers included?",
  answer: "Standard buckets are included with most loaders. Specialized attachments like hydraulic breakers, augers, or pallet forks are available as add-on rentals to suit your specific project requirements."
}, {
  question: "What is your policy on equipment cleaning and fuel?",
  answer: "Equipment should be returned reasonably clean and full of diesel. A cleaning fee or refueling surcharge may apply if the machinery requires extensive washing or tank topping upon return."
}];
export default function CommonInquiries() {
  return <section data-section-id="92343" id="rental-guidelines" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-black text-secondary mb-4 tracking-tighter uppercase">
            Rental Guidelines
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-medium">
            Essential information for contractors and engineers regarding our equipment operation, logistics, and maintenance policies.
          </p>
        </div>

        <div className="bg-card rounded-sm border border-border shadow-sm p-4 md:p-8 mb-12">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
                <AccordionTrigger className="text-base md:text-lg font-bold hover:no-underline hover:text-primary transition-colors text-left py-5">
                  <div className="flex items-baseline gap-4 md:gap-6">
                    <span className="text-primary font-mono text-sm md:text-base font-bold shrink-0">
                      {String(i + 1).padStart(2, '0')}.
                    </span>
                    <span className="text-secondary uppercase tracking-tight">{faq.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pl-10 md:pl-14 pb-6 text-base font-normal">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="text-center bg-accent/20 rounded-sm p-8 md:p-10 border border-border">
          <h3 className="text-xl md:text-2xl font-bold text-secondary mb-3 uppercase tracking-tight">
            Technical Support Needed?
          </h3>
          <p className="text-muted-foreground mb-8 max-w-md mx-auto font-medium">
            Our fleet specialists are available 24/7 to assist with technical specifications or emergency maintenance requests.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto rounded-sm bg-primary hover:bg-primary/90 text-primary-foreground font-bold uppercase tracking-wider">
              <Link to="/BookNowPage">Request a Quote</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-sm border-secondary text-secondary hover:bg-secondary hover:text-secondary-foreground font-bold uppercase tracking-wider">
              <Link to="tel:6232688618">Call</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}